module.exports = __webpack_public_path__ + "static/media/13.920c638f.jpg";